import React, { useState } from "react";

import {
    PageHeader,
    Descriptions,
    Divider,
    Table,
    Popconfirm,
    Button,
    Alert,
    Space,
    Statistic,
    Tooltip,
    Tag,
    List,
    Avatar,
} from "antd";
import {
    QuestionOutlined,
    DownloadOutlined,
    CheckOutlined,
    PaperClipOutlined,
    BankOutlined,
    ContainerOutlined,
} from "@ant-design/icons";
import Moment from "moment";
import { DATE_FORMAT } from "../../../core/utils/i18n-js";

import UploadButton from "../../upload/button";

import PropTypes from "prop-types";

const propTypes = {
    id: PropTypes.number,

    view: PropTypes.oneOf(["Vendor", "Manager"]),
    purchaseOrderStatus: PropTypes.oneOf(["In review", "Accepted"]),

    invoice: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        created_at: PropTypes.string,
    }),

    receipt: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        created_at: PropTypes.string,
    }),

    onUploadInvoice: PropTypes.func,
    onRemoveInvoice: PropTypes.func,
    onDownloadInvoice: PropTypes.func.isRequired,

    onUploadReceipt: PropTypes.func,
    onRemoveReceipt: PropTypes.func,
    onDownloadReceipt: PropTypes.func.isRequired,

    onLockInvoice: PropTypes.func,
    onUnlockInvoice: PropTypes.func,
};

const defaultProps = {
    view: "Vendor",
};

function AttachmentList(props) {
    const { id, receipt, invoice, view } = props;

    const hasReceipt = receipt ? true : false;
    const hasInvoice = invoice ? true : false;

    const receiptName = hasReceipt ? `Receipt / ${receipt.name}` : "Receipt";
    const invoiceName = hasInvoice ? `Invoice / ${invoice.name}` : "Upload invoivce";
    const receiptDescription = hasReceipt ? Moment(receipt.created_at).format(DATE_FORMAT) : "Receipt information.";
    const invoiceDescription = hasInvoice
        ? Moment(invoice.created_at).format(DATE_FORMAT)
        : "Please upload an invoice.";
    const onUploadInvoice = (form) => props.onUploadInvoice(id, form);
    const onUploadReceipt = (form) => props.onUploadReceipt(id, form);
    const onDownloadInvoice = () => props.onDownloadInvoice(id, invoice?.name);
    const onRemoveInvoice = () => props.onRemoveInvoice(id);
    const onDownloadReceipt = () => props.onDownloadReceipt(id, receipt?.name);
    const onRemoveReceipt = () => props.onRemoveReceipt(id);

    const onLockInvoice = () => props.onLockInvoice(id);
    const onUnlockInvoice = () => props.onUnlockInvoice(id);

    const receiptActions = [];

    if (view === "Manager") {
        receiptActions.push(
            <UploadButton
                key="receipt-upload"
                modalLabel="Receipt"
                buttonLabel="Upload receipt"
                onUpload={onUploadReceipt}
            />
        );
    }

    const invoiceActions = [];

    if (hasInvoice) {
        invoiceActions.push(
            <Button key="invoice-download" type="link" onClick={onDownloadInvoice}>
                Download
            </Button>
        );

        if (invoice?.lock === true) {
            if (view === "Manager") {
                invoiceActions.push(
                    <Button key="invoice-unlock" type="link" onClick={onUnlockInvoice}>
                        Unlock
                    </Button>
                );
            }
        } else {
            if (view === "Manager") {
                invoiceActions.push(
                    <Popconfirm
                        key="invoice-lock"
                        title="Are you sure?"
                        onConfirm={onLockInvoice}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button type="link">Confirm</Button>
                    </Popconfirm>
                );
            }

            invoiceActions.push(
                <Popconfirm
                    key="invoice-remove"
                    title="Are you sure?"
                    onConfirm={onRemoveInvoice}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button type="link">Remove</Button>
                </Popconfirm>
            );
        }
    } else {
        invoiceActions.push(
            <UploadButton
                key="invoice-upload"
                modalLabel="Invoice"
                buttonLabel="Upload invoice"
                onUpload={onUploadInvoice}
            />
        );
    }

    const hasReceiptActionsVendor = [
        <Button key="invoice-download" type="link" onClick={onDownloadReceipt}>
            Download
        </Button>,
    ];

    const hasReceiptActions = [
        <Button key="invoice-download" type="link" onClick={onDownloadReceipt}>
            Download
        </Button>,
        <Button key="invoice-remove" type="link" onClick={onRemoveReceipt}>
            Remove
        </Button>,
    ];

    return (
        <PageHeader ghost={false}>
            <List size="small" header={<div>Attachments</div>} bordered>
                <List.Item actions={invoiceActions}>
                    <List.Item.Meta
                        avatar={<Avatar icon={<PaperClipOutlined />} />}
                        title={invoiceName}
                        description={invoiceDescription}
                    />
                </List.Item>

                {hasReceipt && view == "Vendor" && (
                    <List.Item actions={hasReceiptActionsVendor}>
                        <List.Item.Meta
                            avatar={<Avatar icon={<BankOutlined />} />}
                            title={receiptName}
                            description={receiptDescription}
                        />
                    </List.Item>
                )}
                {view == "Manager" && (
                    <List.Item actions={hasReceipt ? hasReceiptActions : receiptActions}>
                        <List.Item.Meta
                            avatar={<Avatar icon={<BankOutlined />} />}
                            title={receiptName}
                            description={receiptDescription}
                        />
                    </List.Item>
                )}
            </List>
        </PageHeader>
    );
}

AttachmentList.propTypes = propTypes;
AttachmentList.defaultProps = defaultProps;

export default AttachmentList;
